import { render, staticRenderFns } from "./TagIndex.vue?vue&type=template&id=1bf2f6f9&scoped=true"
import script from "./TagIndex.vue?vue&type=script&lang=js"
export * from "./TagIndex.vue?vue&type=script&lang=js"
import style0 from "./TagIndex.vue?vue&type=style&index=0&id=1bf2f6f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf2f6f9",
  null
  
)

export default component.exports